<script>
import Component from 'vue-class-component';
import ChipGroup from '@optimizer/components/ChipGroup.vue';
import { Prop } from 'vue-property-decorator';

@Component
export default class SectionChips extends ChipGroup {
  @Prop({ type: Boolean, default: false }) disabled;

  parseGroupInfo(section) {
    const parsedInfo = {};
    this.groupList.forEach((group) => {
      parsedInfo[group.code_name] = {
        label: section.getSectionLabelForDemand(group.code_name),
        emitName: 'group-click',
        emitArgs: { section },
        disabled: this.disabled,
        clickDisabled: false,
      };
    });
    return parsedInfo;
  }
}
</script>
